module.exports = __webpack_public_path__ + "assets/img/37@3x.810d37ef.png";